<p *ngIf="fieldDescription" class="mb-0 mt-2">
  {{ fieldDescription }}{{ getRequired() ? '*' : '' }}
</p>
<mat-form-field
  *ngIf="!readonly"
  class="w-100"
  [floatLabel]="placeholder ? 'always' : 'auto'"
  [ngClass]="{ 'read-only': readonly, 'allow-pointer': tooltipText, 'no-label': hideLabel }"
>
  <mat-label class="mat-subtitle2">
    {{ labelOverride || fgInfo?.label
    }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
    <mat-icon
      [hidden]="!tooltipText"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="'after'"
      [attr.aria-label]="'Tooltip: ' + tooltipText"
      tabindex="0"
    >
      help
    </mat-icon>
  </mat-label>
  <input
    matInput
    [attr.data-automation-id]="dataAutomationId"
    [required]="fgInfo.required"
    [placeholder]="placeholder"
    [formControl]="formControl"
    [mask]="maskConfig?.mask"
    [validation]="false"
    [prefix]="maskConfig?.prefix || ''"
    [patterns]="maskConfig?.patterns"
    [specialCharacters]="maskConfig?.specialCharacters"
    [dropSpecialCharacters]="maskConfig?.dropSpecialCharacters"
    [maxLength]="fgInfo.maxLength"
    [autocomplete]="autocomplete"
    (change)="richChange.emit($event?.target?.value)"
    (blur)="richBlur.emit($event?.target?.value)"
  />
  <mat-hint *ngIf="hasMask && !hint; else noMask">{{ placeholder }}</mat-hint>
  <ng-template #noMask>
    <mat-hint>{{ hint }}</mat-hint>
  </ng-template>
  <mat-error *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </mat-error>
</mat-form-field>
<ng-container *ngIf="readonly && hasMask">
  <mat-form-field
    class="no-underline w-100"
    [ngClass]="{ 'read-only': readonly, 'allow-pointer': tooltipText, 'no-label': hideLabel }"
    [floatLabel]="'always'"
  >
    <mat-label>
      {{ labelOverride || fgInfo?.label }}
      <mat-icon
        [hidden]="!tooltipText"
        [matTooltip]="tooltipText"
        [matTooltipPosition]="'after'"
        [attr.aria-label]="'Tooltip: ' + tooltipText"
        tabindex="0"
      >
        help
      </mat-icon>
    </mat-label>
    <input
      matInput
      readonly
      [placeholder]="placeholder"
      [formControl]="formControl"
      [mask]="maskConfig?.mask"
      [prefix]="maskConfig?.prefix || ''"
      [patterns]="maskConfig?.patterns"
      [specialCharacters]="maskConfig?.specialCharacters"
      [dropSpecialCharacters]="maskConfig?.dropSpecialCharacters"
      tabindex="-1"
    />
  </mat-form-field>
</ng-container>
<ng-container *ngIf="readonly && !hasMask">
  <app-text-area-input
    [hint]="hint"
    [tooltipText]="tooltipText"
    [labelOverride]="labelOverride"
    [placeholder]="placeholder"
    [formInfo]="formInfo"
    [form]="formGroupOverride"
    [controlName]="controlName"
    [data-automation-id]="dataAutomationId"
    [disabled]="disabled"
    [readonly]="readonly"
    [hideLabel]="hideLabel"
    [isTime]="isTime"
    [showCharacterCount]="false"
    [minRows]="1"
  ></app-text-area-input>
</ng-container>
